import * as React from "react";
import { Input, Icon, Button } from "antd";
import Text from "antd/lib/typography/Text";
import whiteLogo from "../../assets/images/headerlogo.png";
import Link from "../../components/app/Link";
import { IRouter } from "../../../runtime/Router";

const LoginForm = ({
  translate,
  username,
  password,
  loginButtonDisabled,
  login,
  onChangeUsername,
  onChangePassword,
  loading,
  title,
  router
}: {
  translate: any;
  username?: string;
  password?: string;
  loginButtonDisabled: boolean;
  login: any;
  onChangeUsername: any;
  onChangePassword: any;
  loading: boolean;
  title: string;
  router: IRouter;
}) => {
  return (
    <div className="login-container">
      <div className="login-header-container">
        <div>
          <img className="logo-container" src={whiteLogo} alt="Logo" />
        </div>

        <div className="login-subheader-container">
          <Text className="login-title">{translate(`app.${title}`)}</Text>
          <Text className="login-subtitle">{translate("app.name")}</Text>
        </div>
      </div>
      <div className="login-form-container">
        <div className="login-title-wrapper">
          <Text className="login-text ">{translate("login.login")}</Text>
        </div>

        <div className="login-form-item-container">
          <Input
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder={translate("login.username")}
            value={username}
            onChange={(e) => onChangeUsername(e.target.value)}
            allowClear={true}
            style={{ marginTop: 35, marginLeft: 50, marginRight: 50 }}
          />
          <Input.Password
            prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder={translate("login.password")}
            value={password}
            onPressEnter={login}
            onChange={(e) => onChangePassword(e.target.value)}
            allowClear={true}
            style={{ marginTop: 20, marginLeft: 50, marginRight: 50 }}
          />
          <Button
            type="primary"
            disabled={loginButtonDisabled}
            onClick={login}
            className="login-button"
            loading={loading}
          >
            {translate("login.login")}
          </Button>
          <div style={{ alignSelf: "start", marginTop: 10 }}>
            <Link router={router} path="/reset-password">
              {translate("login.forgot_password")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
